import './DisableDataSecurityButton.scss';

import { coreActions } from '@sonar-software/sonar-core';
import { FullUserBoundary } from '@ui/general';
import { SonarText } from '@ui/text';
import { useAction } from '@hooks';

import { Button, Popconfirm } from 'antd';
import { CHANGE_EVENT_PREFERENCES, COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';

export interface DisableDataSecurityButtonProps {
	isEnabled: boolean | undefined | null;
}

export const DisableDataSecurityButton: React.FC<DisableDataSecurityButtonProps> = ({ isEnabled }) => {
	const postDataSecurityStatus = useAction(coreActions.requestPostCoreDataSecurityStatus);

	const handleClick = useCallback(() => {
		postDataSecurityStatus({
			enable: false
		});
	}, [ postDataSecurityStatus ]);

	if (!isEnabled) {
		return null;
	}

	return (
		<FullUserBoundary>
			<Popconfirm
				cancelText={ COPY_SPECIFIC.NO }
				classNames={ { root: 'disable-data-security-popover' } }
				okText={ COPY_SPECIFIC.YES }
				onConfirm={ handleClick }
				placement='bottom'
				title={
					<>
						<p>
							<SonarText className='disable-data-security-confirm-message'>
								{ CHANGE_EVENT_PREFERENCES.DISABLE_CONFIRM_LINE1 }
							</SonarText>
						</p>
						<p>
							<SonarText className='disable-data-security-confirm-message'>
								{ CHANGE_EVENT_PREFERENCES.DISABLE_CONFIRM_LINE2 }
							</SonarText>
						</p>
						<p>
							<SonarText className='disable-data-security-confirm-message'>
								{ CHANGE_EVENT_PREFERENCES.DISABLE_CONFIRM_LINE3 }
							</SonarText>
						</p>
					</>
				}>
				<Button
					className='disable-data-security-button'
					type='link'>{ COPY_GENERIC.DISABLE }
				</Button>
			</Popconfirm>
		</FullUserBoundary>
	);
};
